import { Injectable } from '@angular/core';
import { BasePagedCrudService } from "../shared/crud/base-crud.service";
import { CreateUcetniJednotkaInputDto, EditUcetniJednotkaInputDto, UcetniJednotkaDto } from "./models/UcetniJednotkaDtos";
import { HttpClient } from "@angular/common/http";
import { CrudSettings, QueryParams } from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
export class UcetniJednotkaCrudSettings implements CrudSettings<string, UcetniJednotkaDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = "CreateMany";
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'Vse';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: UcetniJednotkaDto) => entity.kod;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('kod', id);
    return {params: dict}
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/StrukturaUcetniJednotky/UcetniJednotka';
  }
}

@Injectable
({
  providedIn: null
})
export class UcetniJednotkaDataService
  extends BasePagedCrudService<string, UcetniJednotkaDto, CreateUcetniJednotkaInputDto, EditUcetniJednotkaInputDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new UcetniJednotkaCrudSettings(environmentService), dialogService);
  }
}
